import { EnhancedWithAuthHttpService } from './http-auth.service'
import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'

import {
  ICreateChallengesDto,
  IMessageResponseDto,
  IChallengesRespDto,
  IUpdateChallengesDto,
  IChallengeInfoRespDto,
  IChallengesBaseWithId,
} from 'src/types'

class ChallengesService extends EnhancedWithAuthHttpService {
  constructor() {
    super(new HttpService(axiosInstance))
  }

  getChallenges(params?: {}) {
    return this.get<IChallengesRespDto>('challenges/', { params })
  }

  getChallengeInfo(id: string) {
    return this.get<IChallengeInfoRespDto>(`challenges/${id}/info`, {})
  }

  getActiveChallenges() {
    return this.get<IChallengesBaseWithId[]>(`challenges/active`, {})
  }

  createChallenge(dto: ICreateChallengesDto) {
    return this.post<IMessageResponseDto, ICreateChallengesDto>('challenges/', dto)
  }

  updateChallenge(id: string, dto: IUpdateChallengesDto) {
    return this.put<IMessageResponseDto, IUpdateChallengesDto>(`challenges/${id}`, dto)
  }

  removeChallenges(ids: string[]) {
    return this.delete<IMessageResponseDto>(`challenges/`, { data: { ids } })
  }
}

export const challengesService = new ChallengesService()
